module.exports = __webpack_public_path__ + "1793882494189/fonts/Metropolis-Bold.87cfcb6.woff2";